import "./PageHome.scss";
import homeAsidePicture from "./homeAsidePicture.png";
import HeaderLine from "../../components/headerLine/HeaderLine";
import News from "../../components/news/News";

export default function PageHome(props) {
  return (
    <div className="page-home">
      <HeaderLine
        language={props.language}
        selectedPage={"home"}
        loginData={props.loginData}
      />

      <article>
        <div className="news-area">
          <News />
        </div>
        <aside>
          <img src={homeAsidePicture} alt="homeAsidePicture.png" />
        </aside>
      </article>
    </div>
  );
}
